
export const capitalDetailRouting = [
  {
    path: "/report-center/download/capital-detail/list",
    name: "capital-detail",
    meta: { title: "资金收支明细表" },
    component: () =>
      import(
        /* webpackChunkName: "labor-wage" */ "@/views/report-center/capital-detail/list/index.vue"
        ),
  },
];
